module.exports = __webpack_public_path__ + "images/emoji/tomato.939b3cd9f6e9147f7ec0.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/tomato.png
// module id = htTf
// module chunks = 1